// extracted by mini-css-extract-plugin
export default {"logo":"HubspotCard_logo__7t+qL"};